// AppLayout.jsx
import React, { useEffect, useState, useMemo, createContext } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { AppProvider } from "@toolpad/core/react-router-dom";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  CssBaseline,
  IconButton,
  Menu,
  MenuItem
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { createTheme } from "@mui/material/styles";
import { jwtDecode } from "jwt-decode";

export const HeaderContext = createContext({
  title: "",
  showBack: false,
  setTitle: () => { },
  setShowBack: () => { },
});

const theme = createTheme({
  typography: { fontFamily: '"IBM Plex Sans Thai", serif' },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: { background: "#fff", color: "#000", boxShadow: "none" },
      },
    },
  },
});

export default function AppLayout() {
  const navigate = useNavigate();

  const [session, setSession] = useState({});
  const [title, setTitle] = useState("");
  const [showBack, setShowBack] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleProfileMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  // load session (เหมือนเดิม)
  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const bow_accessToken = localStorage.getItem("bow_accessToken");

    if (!accessToken || !bow_accessToken) {
      navigate("/auth/login");
      return;
    }
    try {
      const decoded = jwtDecode(accessToken);
      const currentTime = Date.now() / 1000;
      const decoded_bow = jwtDecode(bow_accessToken);

      if (decoded.exp < currentTime || decoded_bow.exp < currentTime) {
        navigate("/auth/login");
      } else {
        setSession({
          user: {
            name: decoded.name,
            lastname: decoded.lastname,
            role: decoded.roleId === 1 ? "โรงพยาบาล" : "สัตวแพทย์",
          },
        });
      }
    } catch (error) {
      navigate("/auth/login");
    }
  }, [navigate]);

  const authentication = useMemo(
    () => ({
      signOut: () => {
        localStorage.removeItem("accessToken");
        setSession(null);
        navigate("/auth/login");
      },
    }),
    [navigate]
  );

  return (
    <AppProvider theme={theme} session={session} authentication={authentication}>
      <HeaderContext.Provider value={{ title, showBack, setTitle, setShowBack }}>
        <CssBaseline />

        <AppBar position="fixed">
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* LEFT: Back button */}
            <Box sx={{ width: 50 }}>
              {showBack && (
                <IconButton color="inherit" edge="start" onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
              )}
            </Box>

            {/* CENTER: Title */}
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                flexGrow: 1,
                fontWeight: 600,
              }}
            >
              {title}
            </Typography>

            {/* RIGHT: Profile icon (เฉพาะเมื่อไม่มี Back) */}
            <Box sx={{ width: 50, textAlign: "right" }}>
              {session.user && (
                <IconButton onClick={handleProfileMenu}>
                  <AccountCircleIcon fontSize="large" />
                </IconButton>
              )}
            </Box>
          </Toolbar>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseMenu}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            {/* <MenuItem
              onClick={() => {
                handleCloseMenu();
                navigate("/profile");
              }}
            >
              View Profile
            </MenuItem> */}

            <MenuItem
              onClick={() => {
                handleCloseMenu();
                localStorage.removeItem("accessToken");
                navigate("/auth/login");
              }}
            >
              Logout
            </MenuItem>
          </Menu>


        </AppBar>

        <Toolbar />

        <Box sx={{ p: 2, minHeight: "100vh", bgcolor: "#f4f6f8" }}>
          <Outlet />
        </Box>
      </HeaderContext.Provider>
    </AppProvider>
  );
}
